// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
            @media screen and (max-width: 960px) {
                :host
                    ::ng-deep
                    .p-datatable.p-datatable-customers.rowexpand-table
                    .p-datatable-tbody
                    > tr
                    > td:nth-child(6) {
                    display: flex;
                }
            }
        `, "",{"version":3,"sources":["webpack://./src/app/argic/view/matrixsearch.component.ts"],"names":[],"mappings":";YACY;gBACI;;;;;;oBAMI,aAAa;gBACjB;YACJ","sourcesContent":["\n            @media screen and (max-width: 960px) {\n                :host\n                    ::ng-deep\n                    .p-datatable.p-datatable-customers.rowexpand-table\n                    .p-datatable-tbody\n                    > tr\n                    > td:nth-child(6) {\n                    display: flex;\n                }\n            }\n        "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
